import { AclEntry, Address } from '@rygen/rygen-ui/model';

export class Contact {
  id?: number;
  name?: string;
  companyName?: string;
  phone?: string;
  email?: string;
  address?: Address;
  acl: AclEntry[] = [];

  constructor(opts?: Partial<Contact>) {
    if (opts?.id != null) {
      this.id = opts.id;
    }
    if (opts?.name != null) {
      this.name = opts.name;
    }
    if (opts?.companyName != null) {
      this.companyName = opts.companyName;
    }
    if (opts?.phone != null) {
      this.phone = opts.phone;
    }
    if (opts?.email != null) {
      this.email = opts.email;
    }
    if (opts?.address != null) {
      this.address = new Address(opts.address);
    }
    if (opts?.acl != null) {
      this.acl = opts.acl.map((acl) => new AclEntry(acl));
    }
  }
}
